import { css } from 'styled-components';
import { focusDarken, px2rem } from '../utils/helpers/style.js';
import { TinyColor } from '@ctrl/tinycolor';
import { generateTextLuminances } from '../utils/helpers/generateTextLuminances.js';

/**
 * Blurs button after certain mouse events to avoid lingering focus styles
 */

var handleButtonUnfocusMouseEvent = function handleButtonUnfocusMouseEvent(onMouseEvent) {
  return function (e) {
    e.stopPropagation();
    e.currentTarget.blur();
    if (onMouseEvent) onMouseEvent(e);
  };
};
var getPlainFocusBg = function getPlainFocusBg(color) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'lighten';
  return mode === 'lighten' ? new TinyColor(color).setAlpha(0.1).toRgbString() : new TinyColor(color).darken(focusDarken).toRgbString();
};
var getButtonStyles = function getButtonStyles() {
  var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'normal';
  return function (props) {
    var luminances = generateTextLuminances(kind, props.theme)(props); // Whether button status / kind inverts colors

    var styleInvert = kind === 'normal' && props.status === 'secondary' || props.status === 'plain';
    var invert = // Never invert disabled styles
    kind !== 'disabled' && // "XOR" styleInvert with props.invert
    styleInvert !== props.invert && ( // Never invert hover, focus, click styles except for plain buttons
    kind !== 'hover' && kind !== 'focus' && kind !== 'click' || props.status === 'plain');
    var fg = invert ? luminances.bg : luminances.fg;
    var bg = invert ? luminances.fg : luminances.bg; // Border is only visible on normal secondary

    var border = kind === 'normal' && props.status === 'secondary'; // Background styles apply for all except non-inverted plain buttons

    var backgroundStyles = props.status === 'plain' && !props.invert ? kind === 'hover' || kind === 'focus' ? css(["background-color:", ";"], getPlainFocusBg(props.color)) : css(["background-color:transparent;"]) : css(["background-color:", ";border:", " solid ", ";"], bg, border ? fg : bg, px2rem(props.theme.button.web.borders.width));
    return css(["color:", ";", ";"], fg, backgroundStyles);
  };
};

export { getButtonStyles, getPlainFocusBg, handleButtonUnfocusMouseEvent };
